<ng-container *ngIf="listOfMachines">
  <div class="filter-component">
    <mat-form-field appearance="outline">
      <mat-label>Operation</mat-label>
      <mat-select
        [(value)]="selectedOperation"
        (selectionChange)="handleSelectChange()"
      >
        <mat-option value="All">All</mat-option>
        <mat-option
          *ngFor="let operation of operations"
          value="{{ operation }}"
          >{{ functonLabel[operation] }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <fieldset class="machine-names" *ngIf="listOfMachines.length">
      <label *ngFor="let machine of listOfMachines" class="radio">
        <span class="radio__input">
          <input
            type="radio"
            [checked]="machine === selectedMachine"
            (change)="handleRadioChange($event)"
            id="{{ machine.id }}"
          />
          <span class="radio__control"></span>
        </span>
        <span class="radio__label">
          {{ machine.name }}
        </span>
      </label>
    </fieldset>
    <ng-container *ngIf="showDateFilter">
      <app-date-quick-chips
        [activeKey]="activeChip"
        (rangeSelected)="onQuickRange($event)"
      ></app-date-quick-chips>
      <mat-form-field appearance="outline">
        <mat-label>Start date</mat-label>
        <input matInput [matDatepicker]="start" [formControl]="startDate" />
        <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
        <mat-datepicker #start></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>End date</mat-label>
        <input matInput [matDatepicker]="end" [formControl]="endDate" />
        <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
        <mat-datepicker #end></mat-datepicker>
      </mat-form-field>
      <button
        mat-stroked-button
        class="apply-filter"
        (click)="handleFilterByDateChanged()"
        [disabled]="disabled"
      >
        Apply
      </button>
    </ng-container>
  </div>
</ng-container>
